import querystring, { type ParsedUrlQueryInput } from 'querystring';
import { ServiceNames } from './serviceNames';

interface FetchrConfig {
    apiUrl: string;
}

export const offerInfoService = {
    resource: ServiceNames.OFFER_INFO_SERVICE,

    read: async (
        _req: unknown,
        _resource: unknown,
        params: ParsedUrlQueryInput,
        config: FetchrConfig,
        callback: (error: unknown, response: unknown) => unknown,
    ): Promise<void> => {
        let { apiUrl } = config;
        if (apiUrl === undefined) {
            // @ts-expect-error _req.apiUrk is not defined in unknown
            apiUrl = _req.apiUrl;
        }
        const url = `${apiUrl}/offer?${params ? querystring.stringify(params) : ''}`;

        try {
            const response = await fetch(url);
            const json = await response.json();

            callback(null, json);
        } catch (e) {
            callback(e, { reason: `failed fetching from ${url}` });
        }
    },
};
